<template>
  <div>
    <b-container fluid class="p-0">
      <b-carousel
        id="carousel"
        v-model="slide"
        :interval="4000"
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;">
        <b-carousel-slide content-visible-up="md" text="FB / IG: @pamelamolinajoyeria | Whatsapp: 5549323191">
          <template #img>
            <img class="d-block img-fluid w-100" :src="slide1" alt="Pamela Molina">
        </template>
        </b-carousel-slide>
      </b-carousel>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
      slide1: require('@/assets/main-slide.jpg'),
      overlay: false,
      products: {
        docs: [],
        total: 0
      },
      slide: null
    }
  },
  methods: {}
}
</script>
